import MyRockets from './MyRockets';
import MyMissions from './MyMissions';

const MyProfile = () => (
  <div className="d-flex my-profile w-100 justify-content-around">
    <MyMissions className="" />
    <MyRockets className="" />
  </div>
);

export default MyProfile;
